// ©2024 Austin App House. All rights reserved.
const values = { name: '', members: [] };

export default values;
